import { DataSource, Layout, LayoutHeader, Table } from "@mcleod/components";

export abstract class AutogenLayoutMobileCommReeferProfileList extends Layout {
    layoutheaderTitle: LayoutHeader;
    sourceMCReeferProfile: DataSource;
    tableMCReefer: Table;
}
